import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";


export default function Pop({ show, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = async (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!/^\d{10,}$/.test(phone)) {
      newErrors.phone = "Enter a valid phone number (min 10 digits)";
    }

    if (!city.trim()) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length !== 0) return;

    try {
      setLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/clients/contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            phone,
            city,
          }),
        }
      );

      const data = await res.json();

      if (data.success) {
        alert("Request submitted successfully!");
        onClose();

        // Reset sform
        setName("");
        setEmail("");
        setPhone("");
        setCity("");
        setErrors({});
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("FORM SUBMIT ERROR:", error);
      alert("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[999] flex items-center justify-center px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-md"
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 30 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="relative bg-white/95 backdrop-blur-xl rounded-3xl 
                       shadow-[0_25px_80px_rgba(0,0,0,0.25)]
                       w-full max-w-lg p-8 border border-white/40"
          >
            {/* Header */}
            <h3 className="text-3xl font-extrabold text-[#253E90] text-center mb-2">
              Door Step Counselling
            </h3>
            <p className="text-sm text-gray-500 text-center mb-6">
              Get expert guidance — we will contact you shortly
            </p>

            {/* Form */}
            <form className="space-y-5" onSubmit={validateForm}>
              {/* Name */}
              <div>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 
                             focus:ring-2 focus:ring-[#253E90] outline-none"
                />
                {errors.name && (
                  <p className="text-xs text-red-500 mt-1">{errors.name}</p>
                )}
              </div>

              {/* Email */}
              <div>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`w-full px-4 py-3 rounded-xl border 
                    ${errors.email ? "border-red-500" : "border-gray-300"}
                    focus:ring-2 focus:ring-[#253E90] outline-none`}
                />
                {errors.email && (
                  <p className="text-xs text-red-500 mt-1">{errors.email}</p>
                )}
              </div>

              {/* Phone */}
              <div>
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) =>
                    setPhone(e.target.value.replace(/\D/g, ""))
                  }
                  className={`w-full px-4 py-3 rounded-xl border 
                    ${errors.phone ? "border-red-500" : "border-gray-300"}
                    focus:ring-2 focus:ring-[#253E90] outline-none`}
                />
                {errors.phone && (
                  <p className="text-xs text-red-500 mt-1">{errors.phone}</p>
                )}
              </div>

              {/* City */}
              <div>
                <input
                  type="text"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className={`w-full px-4 py-3 rounded-xl border 
                    ${errors.city ? "border-red-500" : "border-gray-300"}
                    focus:ring-2 focus:ring-[#253E90] outline-none`}
                />
                {errors.city && (
                  <p className="text-xs text-red-500 mt-1">{errors.city}</p>
                )}
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#253E90] text-white py-3.5 rounded-xl 
                           font-bold hover:bg-[#1e3277] transition-all
                           disabled:opacity-60"
              >
                {loading ? "Submitting..." : "Submit Request"}
              </button>
            </form>

            {/* Close */}
            <button
              onClick={onClose}
              className="absolute top-4 right-5 text-gray-400 hover:text-gray-600 text-xl"
            >
              ✕
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
